import React from 'react';
import { connect } from 'react-redux';
import Producto from './Producto.jsx';

//Importación de actions.
import {
    resetState,
    getScreenData,
    validateAddProduct,
    showMoreBranches,
    noSucursalSelected,
    noSeleccionAmbasReglasAvanzadas,
    errorSave,
    showLessBranches,
    saveSelectedBranches,
    cancelSelectedBranches,
    removeSelectedBranch,
    showMorePurchaseLimits,
    showLessPurchaseLimits,
    saveSelectedPurchaseLimits,
    cancelSelectedPurchaseLimits,
    removeSelectedPurchaseLimit,
    cancelProduct,
    finishProduct,
    getOptionsByField,
    addAdvancedRule,
    removeAdvancedRule,
    duplicateAdvancedRule,
    saveSelectedOptions,
    removeSelectedOption,
    selectCheckBox,
    selectCombo,
    changeInput,
    selectRadio,
    getDataByAdministratorId,
    routing,
    routeToPrevious,
    getGruposafinidad
} from '../actions/Actions.js';


const mapStateToProps = (state) => {
    return {        
        data: state.producto.data,
        redirect: state.producto.redirect,
        isFetching: state.producto.isFetching,
        error: state.producto.error
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },

        getScreenData: (state, currentScope) => {
            dispatch(getScreenData(state, currentScope));
        },

        validateAddProduct: (dataProducto, form) => {
            dispatch(validateAddProduct(dataProducto, form));
        },
        getGruposafinidad: (tipoCuenta) => {
            dispatch(getGruposafinidad(tipoCuenta));
        },

        routing: () => {
            dispatch(routing());
        },

        routeToPrevious: () => {
            dispatch(routeToPrevious());
        },

        showMoreBranches: () => {
            dispatch(showMoreBranches());
        },
        showLessBranches: () => {
            dispatch(showLessBranches());
        },
        noSucursalSelected: () => {
            dispatch(noSucursalSelected());
        },
        noSeleccionAmbasReglasAvanzadas: () => {
            dispatch(noSeleccionAmbasReglasAvanzadas());
        },
        errorSave: () => {
            dispatch(errorSave());
        },
        saveSelectedBranches: (branches, componente) => {
            dispatch(saveSelectedBranches(branches, componente));
        },
        cancelSelectedBranches: (componente) => {
            dispatch(cancelSelectedBranches(componente));
        },
        removeSelectedBranch: (branchId, componente) => {
            dispatch(removeSelectedBranch(branchId, componente));
        },
        showMorePurchaseLimits: () => {
            dispatch(showMorePurchaseLimits());
        },
        showLessPurchaseLimits: () => {
            dispatch(showLessPurchaseLimits());
        },
        saveSelectedPurchaseLimits: (LimiteCompraList) => {
            dispatch(saveSelectedPurchaseLimits(LimiteCompraList));
        },
        cancelSelectedPurchaseLimits: () => {
            dispatch(cancelSelectedPurchaseLimits());
        },
        removeSelectedPurchaseLimit: (purchaseLimitId) => {
            dispatch(removeSelectedPurchaseLimit(purchaseLimitId));
        },
        cancelProduct: () => {
            dispatch(cancelProduct());
        },
        finishProduct: () => {
            dispatch(finishProduct());
        },
        getOptionsByField: (tabla, advancedRuleId, optionsType) => {
            dispatch(getOptionsByField(tabla, advancedRuleId, optionsType));
        },
        addAdvancedRule: (newAdvancedRule) => {
            dispatch(addAdvancedRule(newAdvancedRule));
        },
        removeAdvancedRule: (advancedRuleId) => {
            dispatch(removeAdvancedRule(advancedRuleId));
        },
        duplicateAdvancedRule: (newAdvancedRule) => {
            dispatch(duplicateAdvancedRule(newAdvancedRule));
        },
        saveSelectedOptions: (newAdvancedRule, optionsType) => {
            dispatch(saveSelectedOptions(newAdvancedRule, optionsType));
        },
        removeSelectedOption: (advancedRuleId, optionId, optionsType) => {
            dispatch(removeSelectedOption(advancedRuleId, optionId, optionsType));
        },
        selectCheckBox: (list, item, ...params) => {
            dispatch(selectCheckBox(list, item, params));
        },
        selectCombo: (action, id) => {
            dispatch(selectCombo(action, id));
        },
        changeInput: (action, value) => {
            dispatch(changeInput(action, value));
        },
        selectRadio: (list, item, ...params) => {
            dispatch(selectRadio(list, item, params));
        },
        getDataByAdministratorId: (administratorId, administradoraAbreviatura, tipoCuentaId) => {
            dispatch(getDataByAdministratorId(administratorId, administradoraAbreviatura, tipoCuentaId));
        }
    }
}

//Connect entre el componente y las props y actions.
const ProductoContainer = connect(mapStateToProps, mapDispatchToProps)(Producto);

export default ProductoContainer;